module.exports = __webpack_public_path__ + "img/ladrillos-Hypobrick.38df7ad2.jpg";